
export const GET_CREDIT_LIMIT_MODEL_AT_SECTION_DATA = "GET_CREDIT_LIMIT_MODEL_AT_SECTION_DATA";
export const GET_CREDIT_LIMIT_MODEL_DATA_RESPONSE = "GET_CREDIT_LIMIT_MODEL_DATA_RESPONSE";
export const RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION = "RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION";
export const GET_RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE = "GET_RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE";              
export const SAVE_CREDIT_LIMIT_MODEL_AT_SECTION = "SAVE_CREDIT_LIMIT_MODEL_AT_SECTION";              
export const GET_SAVED_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE = "GET_SAVED_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE";              

export const getCreditLimitModelAtSectionData = (data) => {
    return {
        type: GET_CREDIT_LIMIT_MODEL_AT_SECTION_DATA,
        data
    }
}

export const getCreditLimitModelResponse = (data) => {
    return {
        type: GET_CREDIT_LIMIT_MODEL_DATA_RESPONSE,
        data
    }
}

export const recalculatecreditLimitAtSection = (data) => {
    return {
        type: RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION,
        data
    }
}

export const getRecalculatecreditLimitAtSectionResponse = (data) => {
    return {
        type: GET_RECALCULATE_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE,
        data
    }
}

export const saveCreditLimitModelAtSection = (data) => {
    return {
        type: SAVE_CREDIT_LIMIT_MODEL_AT_SECTION,
        data
    }
}


export const getSavecreditLimitAtSectionResponse = (data) => {
    return {
        type: GET_SAVED_CREDIT_LIMIT_MODEL_AT_SECTION_RESPONSE,
        data
    }
}